module.exports = __webpack_public_path__ + "img/2020_11_dande_moomin_fin_web.eca6f4ea.png";